import { appearTrigger, slideTrigger } from '@myre/ui-primitive-core';

import { type AnimationEvent } from '@angular/animations';
import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';

import { WithToggleDirective } from '../with-toggle/with-toggle.directive';

@Component({
  selector: 'myre-toggle-on',
  template: `
    <ng-template #toggleContent>
      <ng-content></ng-content>
    </ng-template>

    <div
      [@slideTrigger]="state"
      [@appearTrigger]="state"
      (@slideTrigger.done)="onDone($event)"
    >
      @if (show) {
        <ng-container *ngTemplateOutlet="toggleContent"></ng-container>
      }
    </div>
  `,
  animations: [appearTrigger(), slideTrigger],
  styleUrls: ['../toggle.component.scss'],
  imports: [NgTemplateOutlet],
})
export class ToggleOnComponent {
  public myreWithToggle = inject(WithToggleDirective);

  private _show = this.myreWithToggle.myreToggle?.on;

  public get show(): boolean {
    return this._show;
  }

  public get state(): string {
    if (this.myreWithToggle.myreToggle?.on && !this._show) {
      this._show = true;
    }

    return this.myreWithToggle.myreToggle?.on ? 'open' : 'close';
  }

  public onDone(event: AnimationEvent): void {
    if (event.toState === 'close') {
      this._show = false;
    }
  }
}
